define('v3/Common/Components/PupilDropdown/Services/pupilBackend',[
	'jquery',
	'BackendBase'
], function ($, BackendBase) {
	function PupilBackend () {
		BackendBase.call(this);
	};

	PupilBackend.prototype = $.extend({}, BackendBase.prototype);

	$.extend(PupilBackend.prototype, {
		getAllInSubjectGroupsInCurrentClass: function () {
			return this._getJsonApi('Pupils/AllInSubjectGroupsInCurrentClass');
		}
	});

	return new PupilBackend();
});
